// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"186":"1f1ffe64","732":"ed066d9f","944":"b119df01"}[chunkId] + ".css";
};